
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {
/* ForgeContentTools.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");


var $9wGTI = parcelRequire("9wGTI");

/* ForgeContentToolsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
function $ced39bfea5ef5993$export$9f275aff884e1431({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $42omo.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, dialogs: dialogs, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen); // Dialogs may not be needed anymore for live pages - this is a fix for a Forge issue where this is causing re-renders and app is losing context
    // See: https://atlassian.slack.com/archives/CFHD7ERB4/p1755775542436799?thread_ts=1754500884.539789&cid=CFHD7ERB4
    const dialogsProp = (0, $9wGTI.fg)('confluence_skip_dialogs_prop') ? undefined : dialogs;
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB,
        dialogs: dialogsProp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) // Ensures the MoreActions dialog remains opened while the Forge app is running
        // Without this, interactions with any portals from UI Kit components will close the menu which closes the Forge app
        setIsCloseMenuDisabled(true);
        return ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
        };
    }, [
        setIsCloseMenuDisabled
    ]);
    const onInitialRender = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // This ts ignore can be removed once the ff is cleaned up.
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null,
                ...(0, $9wGTI.fg)('confluence_forge_content_type_in_content_actions') ? {
                    type: (0, $hIaUw.getContentType)(routeName)
                } : {}
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: ()=>{
            if ((0, $9wGTI.fg)('forge-ui-content-action-modal-closing-fix')) setIsCloseMenuDisabled(false);
            onClose();
        },
        dialogs: dialogs
    }));
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;
module.exports["forgeGlobalExtensions"] = $af2b0e533822f413$export$492ceb220fc48ad2;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("auPp1"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("eUlIt"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("eZpqL"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("jDKHB"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("6Ylj9"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("lMlPx"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("1bpTV"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("dptHc"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("9Qs7o"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("eqGwa"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("hSSix"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("fdJmS"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("auPp1", function(module, exports) {

let $7a449430ce99d135$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7a449430ce99d135$var$load("2YffH"),
    $7a449430ce99d135$var$load("8Kivm"),
    $7a449430ce99d135$var$load("cf5vC"),
    $7a449430ce99d135$var$load("8lLr0"),
    $7a449430ce99d135$var$load("4NNs0"),
    $7a449430ce99d135$var$load("iQ0Jm"),
    $7a449430ce99d135$var$load("coJiW"),
    $7a449430ce99d135$var$load("8TKWI"),
    $7a449430ce99d135$var$load("RXppq"),
    $7a449430ce99d135$var$load("h4Nf7"),
    $7a449430ce99d135$var$load("7f9Fz"),
    $7a449430ce99d135$var$load("8YSo7"),
    $7a449430ce99d135$var$load("fqGSw"),
    $7a449430ce99d135$var$load("2spqH"),
    $7a449430ce99d135$var$load("gWSdF"),
    $7a449430ce99d135$var$load("6FuHS"),
    $7a449430ce99d135$var$load("eyaRC"),
    $7a449430ce99d135$var$load("g9CVe"),
    $7a449430ce99d135$var$load("aeEUI"),
    $7a449430ce99d135$var$load("iXzmH"),
    $7a449430ce99d135$var$load("65c4i"),
    $7a449430ce99d135$var$load("6wr18"),
    $7a449430ce99d135$var$load("kjZZD"),
    $7a449430ce99d135$var$load("3TTZL"),
    $7a449430ce99d135$var$load("37ldp"),
    $7a449430ce99d135$var$load("awqCy"),
    $7a449430ce99d135$var$load("kHOMt"),
    $7a449430ce99d135$var$load("hhss7"),
    $7a449430ce99d135$var$load("4kjaz"),
    $7a449430ce99d135$var$load("jE6Ik"),
    $7a449430ce99d135$var$load("dlZSj"),
    $7a449430ce99d135$var$load("Wowvf"),
    $7a449430ce99d135$var$load("dS0Pr"),
    $7a449430ce99d135$var$load("huYla"),
    $7a449430ce99d135$var$load("76Z06"),
    $7a449430ce99d135$var$load("6ojHB"),
    $7a449430ce99d135$var$load("ccoZQ"),
    $7a449430ce99d135$var$load("let0D"),
    $7a449430ce99d135$var$load("6EQss"),
    $7a449430ce99d135$var$load("6M36W"),
    $7a449430ce99d135$var$load("ffEVr"),
    $7a449430ce99d135$var$load("kUbUu"),
    $7a449430ce99d135$var$load("9ftJe"),
    $7a449430ce99d135$var$load("hUIij"),
    $7a449430ce99d135$var$load("6Up0b"),
    $7a449430ce99d135$var$load("lnKog"),
    $7a449430ce99d135$var$load("7Omhy"),
    $7a449430ce99d135$var$load("kC80R"),
    $7a449430ce99d135$var$load("7EorR"),
    $7a449430ce99d135$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("eUlIt", function(module, exports) {

let $ada7240a3a76d647$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ada7240a3a76d647$var$load("2YffH"),
    $ada7240a3a76d647$var$load("8Kivm"),
    $ada7240a3a76d647$var$load("cf5vC"),
    $ada7240a3a76d647$var$load("8lLr0"),
    $ada7240a3a76d647$var$load("4NNs0"),
    $ada7240a3a76d647$var$load("iQ0Jm"),
    $ada7240a3a76d647$var$load("coJiW"),
    $ada7240a3a76d647$var$load("8TKWI"),
    $ada7240a3a76d647$var$load("RXppq"),
    $ada7240a3a76d647$var$load("h4Nf7"),
    $ada7240a3a76d647$var$load("7f9Fz"),
    $ada7240a3a76d647$var$load("8YSo7"),
    $ada7240a3a76d647$var$load("fqGSw"),
    $ada7240a3a76d647$var$load("2spqH"),
    $ada7240a3a76d647$var$load("gWSdF"),
    $ada7240a3a76d647$var$load("6FuHS"),
    $ada7240a3a76d647$var$load("eyaRC"),
    $ada7240a3a76d647$var$load("g9CVe"),
    $ada7240a3a76d647$var$load("aeEUI"),
    $ada7240a3a76d647$var$load("iXzmH"),
    $ada7240a3a76d647$var$load("65c4i"),
    $ada7240a3a76d647$var$load("6wr18"),
    $ada7240a3a76d647$var$load("kjZZD"),
    $ada7240a3a76d647$var$load("3TTZL"),
    $ada7240a3a76d647$var$load("37ldp"),
    $ada7240a3a76d647$var$load("awqCy"),
    $ada7240a3a76d647$var$load("kHOMt"),
    $ada7240a3a76d647$var$load("hhss7"),
    $ada7240a3a76d647$var$load("4kjaz"),
    $ada7240a3a76d647$var$load("jE6Ik"),
    $ada7240a3a76d647$var$load("dlZSj"),
    $ada7240a3a76d647$var$load("Wowvf"),
    $ada7240a3a76d647$var$load("dS0Pr"),
    $ada7240a3a76d647$var$load("huYla"),
    $ada7240a3a76d647$var$load("76Z06"),
    $ada7240a3a76d647$var$load("6ojHB"),
    $ada7240a3a76d647$var$load("ccoZQ"),
    $ada7240a3a76d647$var$load("let0D"),
    $ada7240a3a76d647$var$load("6EQss"),
    $ada7240a3a76d647$var$load("6M36W"),
    $ada7240a3a76d647$var$load("ffEVr"),
    $ada7240a3a76d647$var$load("kUbUu"),
    $ada7240a3a76d647$var$load("9ftJe"),
    $ada7240a3a76d647$var$load("hUIij"),
    $ada7240a3a76d647$var$load("6Up0b"),
    $ada7240a3a76d647$var$load("lnKog"),
    $ada7240a3a76d647$var$load("7Omhy"),
    $ada7240a3a76d647$var$load("kC80R"),
    $ada7240a3a76d647$var$load("7EorR"),
    $ada7240a3a76d647$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("eZpqL", function(module, exports) {

let $ae9a7d33f99a3266$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae9a7d33f99a3266$var$load("2YffH"),
    $ae9a7d33f99a3266$var$load("8Kivm"),
    $ae9a7d33f99a3266$var$load("cf5vC"),
    $ae9a7d33f99a3266$var$load("8lLr0"),
    $ae9a7d33f99a3266$var$load("4NNs0"),
    $ae9a7d33f99a3266$var$load("iQ0Jm"),
    $ae9a7d33f99a3266$var$load("coJiW"),
    $ae9a7d33f99a3266$var$load("8TKWI"),
    $ae9a7d33f99a3266$var$load("RXppq"),
    $ae9a7d33f99a3266$var$load("h4Nf7"),
    $ae9a7d33f99a3266$var$load("7f9Fz"),
    $ae9a7d33f99a3266$var$load("8YSo7"),
    $ae9a7d33f99a3266$var$load("fqGSw"),
    $ae9a7d33f99a3266$var$load("2spqH"),
    $ae9a7d33f99a3266$var$load("gWSdF"),
    $ae9a7d33f99a3266$var$load("6FuHS"),
    $ae9a7d33f99a3266$var$load("eyaRC"),
    $ae9a7d33f99a3266$var$load("g9CVe"),
    $ae9a7d33f99a3266$var$load("aeEUI"),
    $ae9a7d33f99a3266$var$load("iXzmH"),
    $ae9a7d33f99a3266$var$load("65c4i"),
    $ae9a7d33f99a3266$var$load("6wr18"),
    $ae9a7d33f99a3266$var$load("kjZZD"),
    $ae9a7d33f99a3266$var$load("3TTZL"),
    $ae9a7d33f99a3266$var$load("37ldp"),
    $ae9a7d33f99a3266$var$load("awqCy"),
    $ae9a7d33f99a3266$var$load("kHOMt"),
    $ae9a7d33f99a3266$var$load("hhss7"),
    $ae9a7d33f99a3266$var$load("4kjaz"),
    $ae9a7d33f99a3266$var$load("jE6Ik"),
    $ae9a7d33f99a3266$var$load("dlZSj"),
    $ae9a7d33f99a3266$var$load("Wowvf"),
    $ae9a7d33f99a3266$var$load("dS0Pr"),
    $ae9a7d33f99a3266$var$load("huYla"),
    $ae9a7d33f99a3266$var$load("76Z06"),
    $ae9a7d33f99a3266$var$load("6ojHB"),
    $ae9a7d33f99a3266$var$load("ccoZQ"),
    $ae9a7d33f99a3266$var$load("let0D"),
    $ae9a7d33f99a3266$var$load("6EQss"),
    $ae9a7d33f99a3266$var$load("6M36W"),
    $ae9a7d33f99a3266$var$load("ffEVr"),
    $ae9a7d33f99a3266$var$load("kUbUu"),
    $ae9a7d33f99a3266$var$load("9ftJe"),
    $ae9a7d33f99a3266$var$load("hUIij"),
    $ae9a7d33f99a3266$var$load("6Up0b"),
    $ae9a7d33f99a3266$var$load("lnKog"),
    $ae9a7d33f99a3266$var$load("7Omhy"),
    $ae9a7d33f99a3266$var$load("kC80R"),
    $ae9a7d33f99a3266$var$load("7EorR"),
    $ae9a7d33f99a3266$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("jDKHB", function(module, exports) {

let $e4c5e2eb94846c22$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4c5e2eb94846c22$var$load("6FuHS"),
    $e4c5e2eb94846c22$var$load("eyaRC"),
    $e4c5e2eb94846c22$var$load("2YffH"),
    $e4c5e2eb94846c22$var$load("cf5vC"),
    $e4c5e2eb94846c22$var$load("8lLr0"),
    $e4c5e2eb94846c22$var$load("4NNs0"),
    $e4c5e2eb94846c22$var$load("8TKWI"),
    $e4c5e2eb94846c22$var$load("RXppq"),
    $e4c5e2eb94846c22$var$load("h4Nf7"),
    $e4c5e2eb94846c22$var$load("7f9Fz"),
    $e4c5e2eb94846c22$var$load("8YSo7"),
    $e4c5e2eb94846c22$var$load("fqGSw"),
    $e4c5e2eb94846c22$var$load("2spqH"),
    $e4c5e2eb94846c22$var$load("gWSdF"),
    $e4c5e2eb94846c22$var$load("g9CVe"),
    $e4c5e2eb94846c22$var$load("aeEUI"),
    $e4c5e2eb94846c22$var$load("iXzmH"),
    $e4c5e2eb94846c22$var$load("65c4i"),
    $e4c5e2eb94846c22$var$load("6wr18"),
    $e4c5e2eb94846c22$var$load("kjZZD"),
    $e4c5e2eb94846c22$var$load("3TTZL"),
    $e4c5e2eb94846c22$var$load("37ldp"),
    $e4c5e2eb94846c22$var$load("awqCy"),
    $e4c5e2eb94846c22$var$load("kHOMt"),
    $e4c5e2eb94846c22$var$load("hhss7"),
    $e4c5e2eb94846c22$var$load("4kjaz"),
    $e4c5e2eb94846c22$var$load("jE6Ik"),
    $e4c5e2eb94846c22$var$load("dlZSj"),
    $e4c5e2eb94846c22$var$load("Wowvf"),
    $e4c5e2eb94846c22$var$load("dS0Pr"),
    $e4c5e2eb94846c22$var$load("huYla"),
    $e4c5e2eb94846c22$var$load("76Z06"),
    $e4c5e2eb94846c22$var$load("6ojHB"),
    $e4c5e2eb94846c22$var$load("ccoZQ"),
    $e4c5e2eb94846c22$var$load("let0D"),
    $e4c5e2eb94846c22$var$load("6EQss"),
    $e4c5e2eb94846c22$var$load("6M36W"),
    $e4c5e2eb94846c22$var$load("hUIij"),
    $e4c5e2eb94846c22$var$load("ffEVr"),
    $e4c5e2eb94846c22$var$load("kUbUu"),
    $e4c5e2eb94846c22$var$load("9ftJe"),
    $e4c5e2eb94846c22$var$load("7Omhy"),
    $e4c5e2eb94846c22$var$load("kC80R"),
    $e4c5e2eb94846c22$var$load("7EorR"),
    $e4c5e2eb94846c22$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("6Ylj9", function(module, exports) {

let $5138dffeeed4c6bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5138dffeeed4c6bc$var$load("6FuHS"),
    $5138dffeeed4c6bc$var$load("eyaRC"),
    $5138dffeeed4c6bc$var$load("2YffH"),
    $5138dffeeed4c6bc$var$load("cf5vC"),
    $5138dffeeed4c6bc$var$load("8lLr0"),
    $5138dffeeed4c6bc$var$load("4NNs0"),
    $5138dffeeed4c6bc$var$load("8TKWI"),
    $5138dffeeed4c6bc$var$load("RXppq"),
    $5138dffeeed4c6bc$var$load("h4Nf7"),
    $5138dffeeed4c6bc$var$load("7f9Fz"),
    $5138dffeeed4c6bc$var$load("8YSo7"),
    $5138dffeeed4c6bc$var$load("fqGSw"),
    $5138dffeeed4c6bc$var$load("2spqH"),
    $5138dffeeed4c6bc$var$load("gWSdF"),
    $5138dffeeed4c6bc$var$load("g9CVe"),
    $5138dffeeed4c6bc$var$load("aeEUI"),
    $5138dffeeed4c6bc$var$load("iXzmH"),
    $5138dffeeed4c6bc$var$load("65c4i"),
    $5138dffeeed4c6bc$var$load("6wr18"),
    $5138dffeeed4c6bc$var$load("kjZZD"),
    $5138dffeeed4c6bc$var$load("3TTZL"),
    $5138dffeeed4c6bc$var$load("37ldp"),
    $5138dffeeed4c6bc$var$load("awqCy"),
    $5138dffeeed4c6bc$var$load("kHOMt"),
    $5138dffeeed4c6bc$var$load("hhss7"),
    $5138dffeeed4c6bc$var$load("4kjaz"),
    $5138dffeeed4c6bc$var$load("jE6Ik"),
    $5138dffeeed4c6bc$var$load("dlZSj"),
    $5138dffeeed4c6bc$var$load("Wowvf"),
    $5138dffeeed4c6bc$var$load("dS0Pr"),
    $5138dffeeed4c6bc$var$load("huYla"),
    $5138dffeeed4c6bc$var$load("76Z06"),
    $5138dffeeed4c6bc$var$load("6ojHB"),
    $5138dffeeed4c6bc$var$load("ccoZQ"),
    $5138dffeeed4c6bc$var$load("let0D"),
    $5138dffeeed4c6bc$var$load("6EQss"),
    $5138dffeeed4c6bc$var$load("6M36W"),
    $5138dffeeed4c6bc$var$load("hUIij"),
    $5138dffeeed4c6bc$var$load("ffEVr"),
    $5138dffeeed4c6bc$var$load("kUbUu"),
    $5138dffeeed4c6bc$var$load("9ftJe"),
    $5138dffeeed4c6bc$var$load("7Omhy"),
    $5138dffeeed4c6bc$var$load("kC80R"),
    $5138dffeeed4c6bc$var$load("7EorR"),
    $5138dffeeed4c6bc$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("lMlPx", function(module, exports) {

let $fdaf03b00a19af4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fdaf03b00a19af4c$var$load("6FuHS"),
    $fdaf03b00a19af4c$var$load("eyaRC"),
    $fdaf03b00a19af4c$var$load("2YffH"),
    $fdaf03b00a19af4c$var$load("cf5vC"),
    $fdaf03b00a19af4c$var$load("8lLr0"),
    $fdaf03b00a19af4c$var$load("4NNs0"),
    $fdaf03b00a19af4c$var$load("8TKWI"),
    $fdaf03b00a19af4c$var$load("RXppq"),
    $fdaf03b00a19af4c$var$load("h4Nf7"),
    $fdaf03b00a19af4c$var$load("7f9Fz"),
    $fdaf03b00a19af4c$var$load("8YSo7"),
    $fdaf03b00a19af4c$var$load("fqGSw"),
    $fdaf03b00a19af4c$var$load("2spqH"),
    $fdaf03b00a19af4c$var$load("gWSdF"),
    $fdaf03b00a19af4c$var$load("g9CVe"),
    $fdaf03b00a19af4c$var$load("aeEUI"),
    $fdaf03b00a19af4c$var$load("iXzmH"),
    $fdaf03b00a19af4c$var$load("65c4i"),
    $fdaf03b00a19af4c$var$load("6wr18"),
    $fdaf03b00a19af4c$var$load("kjZZD"),
    $fdaf03b00a19af4c$var$load("3TTZL"),
    $fdaf03b00a19af4c$var$load("37ldp"),
    $fdaf03b00a19af4c$var$load("awqCy"),
    $fdaf03b00a19af4c$var$load("kHOMt"),
    $fdaf03b00a19af4c$var$load("hhss7"),
    $fdaf03b00a19af4c$var$load("4kjaz"),
    $fdaf03b00a19af4c$var$load("jE6Ik"),
    $fdaf03b00a19af4c$var$load("dlZSj"),
    $fdaf03b00a19af4c$var$load("Wowvf"),
    $fdaf03b00a19af4c$var$load("dS0Pr"),
    $fdaf03b00a19af4c$var$load("huYla"),
    $fdaf03b00a19af4c$var$load("76Z06"),
    $fdaf03b00a19af4c$var$load("6ojHB"),
    $fdaf03b00a19af4c$var$load("ccoZQ"),
    $fdaf03b00a19af4c$var$load("let0D"),
    $fdaf03b00a19af4c$var$load("6EQss"),
    $fdaf03b00a19af4c$var$load("6M36W"),
    $fdaf03b00a19af4c$var$load("hUIij"),
    $fdaf03b00a19af4c$var$load("ffEVr"),
    $fdaf03b00a19af4c$var$load("kUbUu"),
    $fdaf03b00a19af4c$var$load("9ftJe"),
    $fdaf03b00a19af4c$var$load("7Omhy"),
    $fdaf03b00a19af4c$var$load("kC80R"),
    $fdaf03b00a19af4c$var$load("7EorR"),
    $fdaf03b00a19af4c$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("1bpTV", function(module, exports) {

let $0dcae8ec42a04662$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0dcae8ec42a04662$var$load("6FuHS"),
    $0dcae8ec42a04662$var$load("eyaRC"),
    $0dcae8ec42a04662$var$load("2YffH"),
    $0dcae8ec42a04662$var$load("cf5vC"),
    $0dcae8ec42a04662$var$load("8lLr0"),
    $0dcae8ec42a04662$var$load("4NNs0"),
    $0dcae8ec42a04662$var$load("8TKWI"),
    $0dcae8ec42a04662$var$load("RXppq"),
    $0dcae8ec42a04662$var$load("h4Nf7"),
    $0dcae8ec42a04662$var$load("7f9Fz"),
    $0dcae8ec42a04662$var$load("8YSo7"),
    $0dcae8ec42a04662$var$load("fqGSw"),
    $0dcae8ec42a04662$var$load("2spqH"),
    $0dcae8ec42a04662$var$load("gWSdF"),
    $0dcae8ec42a04662$var$load("g9CVe"),
    $0dcae8ec42a04662$var$load("aeEUI"),
    $0dcae8ec42a04662$var$load("iXzmH"),
    $0dcae8ec42a04662$var$load("65c4i"),
    $0dcae8ec42a04662$var$load("6wr18"),
    $0dcae8ec42a04662$var$load("kjZZD"),
    $0dcae8ec42a04662$var$load("3TTZL"),
    $0dcae8ec42a04662$var$load("37ldp"),
    $0dcae8ec42a04662$var$load("awqCy"),
    $0dcae8ec42a04662$var$load("kHOMt"),
    $0dcae8ec42a04662$var$load("hhss7"),
    $0dcae8ec42a04662$var$load("4kjaz"),
    $0dcae8ec42a04662$var$load("jE6Ik"),
    $0dcae8ec42a04662$var$load("dlZSj"),
    $0dcae8ec42a04662$var$load("Wowvf"),
    $0dcae8ec42a04662$var$load("dS0Pr"),
    $0dcae8ec42a04662$var$load("huYla"),
    $0dcae8ec42a04662$var$load("76Z06"),
    $0dcae8ec42a04662$var$load("6ojHB"),
    $0dcae8ec42a04662$var$load("ccoZQ"),
    $0dcae8ec42a04662$var$load("let0D"),
    $0dcae8ec42a04662$var$load("6EQss"),
    $0dcae8ec42a04662$var$load("6M36W"),
    $0dcae8ec42a04662$var$load("ffEVr"),
    $0dcae8ec42a04662$var$load("kUbUu"),
    $0dcae8ec42a04662$var$load("9ftJe"),
    $0dcae8ec42a04662$var$load("hUIij"),
    $0dcae8ec42a04662$var$load("6Up0b"),
    $0dcae8ec42a04662$var$load("lnKog"),
    $0dcae8ec42a04662$var$load("7Omhy"),
    $0dcae8ec42a04662$var$load("kC80R"),
    $0dcae8ec42a04662$var$load("7EorR"),
    $0dcae8ec42a04662$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("dptHc", function(module, exports) {

let $9c34a518abf9ed4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9c34a518abf9ed4a$var$load("2YffH"),
    $9c34a518abf9ed4a$var$load("cf5vC"),
    $9c34a518abf9ed4a$var$load("8lLr0"),
    $9c34a518abf9ed4a$var$load("4NNs0"),
    $9c34a518abf9ed4a$var$load("coJiW"),
    $9c34a518abf9ed4a$var$load("8TKWI"),
    $9c34a518abf9ed4a$var$load("RXppq"),
    $9c34a518abf9ed4a$var$load("h4Nf7"),
    $9c34a518abf9ed4a$var$load("7f9Fz"),
    $9c34a518abf9ed4a$var$load("8YSo7"),
    $9c34a518abf9ed4a$var$load("fqGSw"),
    $9c34a518abf9ed4a$var$load("2spqH"),
    $9c34a518abf9ed4a$var$load("gWSdF"),
    $9c34a518abf9ed4a$var$load("6FuHS"),
    $9c34a518abf9ed4a$var$load("eyaRC"),
    $9c34a518abf9ed4a$var$load("g9CVe"),
    $9c34a518abf9ed4a$var$load("aeEUI"),
    $9c34a518abf9ed4a$var$load("iXzmH"),
    $9c34a518abf9ed4a$var$load("65c4i"),
    $9c34a518abf9ed4a$var$load("6wr18"),
    $9c34a518abf9ed4a$var$load("kjZZD"),
    $9c34a518abf9ed4a$var$load("3TTZL"),
    $9c34a518abf9ed4a$var$load("37ldp"),
    $9c34a518abf9ed4a$var$load("dTsOE"),
    $9c34a518abf9ed4a$var$load("awqCy"),
    $9c34a518abf9ed4a$var$load("kHOMt"),
    $9c34a518abf9ed4a$var$load("hhss7"),
    $9c34a518abf9ed4a$var$load("4kjaz"),
    $9c34a518abf9ed4a$var$load("jE6Ik"),
    $9c34a518abf9ed4a$var$load("dlZSj"),
    $9c34a518abf9ed4a$var$load("Wowvf"),
    $9c34a518abf9ed4a$var$load("dS0Pr"),
    $9c34a518abf9ed4a$var$load("huYla"),
    $9c34a518abf9ed4a$var$load("76Z06"),
    $9c34a518abf9ed4a$var$load("6ojHB"),
    $9c34a518abf9ed4a$var$load("ccoZQ"),
    $9c34a518abf9ed4a$var$load("let0D"),
    $9c34a518abf9ed4a$var$load("6EQss"),
    $9c34a518abf9ed4a$var$load("6M36W"),
    $9c34a518abf9ed4a$var$load("ffEVr"),
    $9c34a518abf9ed4a$var$load("kUbUu"),
    $9c34a518abf9ed4a$var$load("9ftJe"),
    $9c34a518abf9ed4a$var$load("hUIij"),
    $9c34a518abf9ed4a$var$load("6Up0b"),
    $9c34a518abf9ed4a$var$load("lnKog"),
    $9c34a518abf9ed4a$var$load("7Omhy"),
    $9c34a518abf9ed4a$var$load("kC80R"),
    $9c34a518abf9ed4a$var$load("7EorR"),
    $9c34a518abf9ed4a$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("9Qs7o", function(module, exports) {

let $72aec810482c60b6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $72aec810482c60b6$var$load("2YffH"),
    $72aec810482c60b6$var$load("cf5vC"),
    $72aec810482c60b6$var$load("8lLr0"),
    $72aec810482c60b6$var$load("4NNs0"),
    $72aec810482c60b6$var$load("coJiW"),
    $72aec810482c60b6$var$load("8TKWI"),
    $72aec810482c60b6$var$load("RXppq"),
    $72aec810482c60b6$var$load("h4Nf7"),
    $72aec810482c60b6$var$load("7f9Fz"),
    $72aec810482c60b6$var$load("8YSo7"),
    $72aec810482c60b6$var$load("fqGSw"),
    $72aec810482c60b6$var$load("2spqH"),
    $72aec810482c60b6$var$load("gWSdF"),
    $72aec810482c60b6$var$load("6FuHS"),
    $72aec810482c60b6$var$load("eyaRC"),
    $72aec810482c60b6$var$load("g9CVe"),
    $72aec810482c60b6$var$load("aeEUI"),
    $72aec810482c60b6$var$load("iXzmH"),
    $72aec810482c60b6$var$load("65c4i"),
    $72aec810482c60b6$var$load("6wr18"),
    $72aec810482c60b6$var$load("kjZZD"),
    $72aec810482c60b6$var$load("3TTZL"),
    $72aec810482c60b6$var$load("37ldp"),
    $72aec810482c60b6$var$load("dTsOE"),
    $72aec810482c60b6$var$load("awqCy"),
    $72aec810482c60b6$var$load("kHOMt"),
    $72aec810482c60b6$var$load("hhss7"),
    $72aec810482c60b6$var$load("4kjaz"),
    $72aec810482c60b6$var$load("jE6Ik"),
    $72aec810482c60b6$var$load("dlZSj"),
    $72aec810482c60b6$var$load("Wowvf"),
    $72aec810482c60b6$var$load("dS0Pr"),
    $72aec810482c60b6$var$load("huYla"),
    $72aec810482c60b6$var$load("76Z06"),
    $72aec810482c60b6$var$load("6ojHB"),
    $72aec810482c60b6$var$load("ccoZQ"),
    $72aec810482c60b6$var$load("let0D"),
    $72aec810482c60b6$var$load("6EQss"),
    $72aec810482c60b6$var$load("6M36W"),
    $72aec810482c60b6$var$load("ffEVr"),
    $72aec810482c60b6$var$load("kUbUu"),
    $72aec810482c60b6$var$load("9ftJe"),
    $72aec810482c60b6$var$load("hUIij"),
    $72aec810482c60b6$var$load("6Up0b"),
    $72aec810482c60b6$var$load("lnKog"),
    $72aec810482c60b6$var$load("7Omhy"),
    $72aec810482c60b6$var$load("kC80R"),
    $72aec810482c60b6$var$load("7EorR"),
    $72aec810482c60b6$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("eqGwa", function(module, exports) {

let $a81479870758d104$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a81479870758d104$var$load("6FuHS"),
    $a81479870758d104$var$load("eyaRC"),
    $a81479870758d104$var$load("2YffH"),
    $a81479870758d104$var$load("cf5vC"),
    $a81479870758d104$var$load("8lLr0"),
    $a81479870758d104$var$load("4NNs0"),
    $a81479870758d104$var$load("8TKWI"),
    $a81479870758d104$var$load("RXppq"),
    $a81479870758d104$var$load("h4Nf7"),
    $a81479870758d104$var$load("7f9Fz"),
    $a81479870758d104$var$load("8YSo7"),
    $a81479870758d104$var$load("fqGSw"),
    $a81479870758d104$var$load("2spqH"),
    $a81479870758d104$var$load("gWSdF"),
    $a81479870758d104$var$load("g9CVe"),
    $a81479870758d104$var$load("aeEUI"),
    $a81479870758d104$var$load("iXzmH"),
    $a81479870758d104$var$load("65c4i"),
    $a81479870758d104$var$load("6wr18"),
    $a81479870758d104$var$load("kjZZD"),
    $a81479870758d104$var$load("3TTZL"),
    $a81479870758d104$var$load("37ldp"),
    $a81479870758d104$var$load("awqCy"),
    $a81479870758d104$var$load("kHOMt"),
    $a81479870758d104$var$load("hhss7"),
    $a81479870758d104$var$load("4kjaz"),
    $a81479870758d104$var$load("jE6Ik"),
    $a81479870758d104$var$load("dlZSj"),
    $a81479870758d104$var$load("Wowvf"),
    $a81479870758d104$var$load("dS0Pr"),
    $a81479870758d104$var$load("huYla"),
    $a81479870758d104$var$load("76Z06"),
    $a81479870758d104$var$load("6ojHB"),
    $a81479870758d104$var$load("ccoZQ"),
    $a81479870758d104$var$load("let0D"),
    $a81479870758d104$var$load("6EQss"),
    $a81479870758d104$var$load("6M36W"),
    $a81479870758d104$var$load("hUIij"),
    $a81479870758d104$var$load("ffEVr"),
    $a81479870758d104$var$load("kUbUu"),
    $a81479870758d104$var$load("9ftJe"),
    $a81479870758d104$var$load("7Omhy"),
    $a81479870758d104$var$load("kC80R"),
    $a81479870758d104$var$load("7EorR"),
    $a81479870758d104$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("hSSix", function(module, exports) {

let $d051994211f00cca$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d051994211f00cca$var$load("6FuHS"),
    $d051994211f00cca$var$load("eyaRC"),
    $d051994211f00cca$var$load("2YffH"),
    $d051994211f00cca$var$load("cf5vC"),
    $d051994211f00cca$var$load("8lLr0"),
    $d051994211f00cca$var$load("4NNs0"),
    $d051994211f00cca$var$load("8TKWI"),
    $d051994211f00cca$var$load("RXppq"),
    $d051994211f00cca$var$load("h4Nf7"),
    $d051994211f00cca$var$load("7f9Fz"),
    $d051994211f00cca$var$load("8YSo7"),
    $d051994211f00cca$var$load("fqGSw"),
    $d051994211f00cca$var$load("2spqH"),
    $d051994211f00cca$var$load("gWSdF"),
    $d051994211f00cca$var$load("g9CVe"),
    $d051994211f00cca$var$load("aeEUI"),
    $d051994211f00cca$var$load("iXzmH"),
    $d051994211f00cca$var$load("65c4i"),
    $d051994211f00cca$var$load("6wr18"),
    $d051994211f00cca$var$load("kjZZD"),
    $d051994211f00cca$var$load("3TTZL"),
    $d051994211f00cca$var$load("37ldp"),
    $d051994211f00cca$var$load("awqCy"),
    $d051994211f00cca$var$load("kHOMt"),
    $d051994211f00cca$var$load("hhss7"),
    $d051994211f00cca$var$load("4kjaz"),
    $d051994211f00cca$var$load("jE6Ik"),
    $d051994211f00cca$var$load("dlZSj"),
    $d051994211f00cca$var$load("Wowvf"),
    $d051994211f00cca$var$load("dS0Pr"),
    $d051994211f00cca$var$load("huYla"),
    $d051994211f00cca$var$load("76Z06"),
    $d051994211f00cca$var$load("6ojHB"),
    $d051994211f00cca$var$load("ccoZQ"),
    $d051994211f00cca$var$load("let0D"),
    $d051994211f00cca$var$load("6EQss"),
    $d051994211f00cca$var$load("6M36W"),
    $d051994211f00cca$var$load("ffEVr"),
    $d051994211f00cca$var$load("kUbUu"),
    $d051994211f00cca$var$load("9ftJe"),
    $d051994211f00cca$var$load("hUIij"),
    $d051994211f00cca$var$load("6Up0b"),
    $d051994211f00cca$var$load("lnKog"),
    $d051994211f00cca$var$load("7Omhy"),
    $d051994211f00cca$var$load("kC80R"),
    $d051994211f00cca$var$load("7EorR"),
    $d051994211f00cca$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("fdJmS", function(module, exports) {

let $b14b430a0537b433$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b14b430a0537b433$var$load("6FuHS"),
    $b14b430a0537b433$var$load("eyaRC"),
    $b14b430a0537b433$var$load("2YffH"),
    $b14b430a0537b433$var$load("cf5vC"),
    $b14b430a0537b433$var$load("8lLr0"),
    $b14b430a0537b433$var$load("4NNs0"),
    $b14b430a0537b433$var$load("8TKWI"),
    $b14b430a0537b433$var$load("RXppq"),
    $b14b430a0537b433$var$load("h4Nf7"),
    $b14b430a0537b433$var$load("7f9Fz"),
    $b14b430a0537b433$var$load("8YSo7"),
    $b14b430a0537b433$var$load("fqGSw"),
    $b14b430a0537b433$var$load("2spqH"),
    $b14b430a0537b433$var$load("gWSdF"),
    $b14b430a0537b433$var$load("g9CVe"),
    $b14b430a0537b433$var$load("aeEUI"),
    $b14b430a0537b433$var$load("iXzmH"),
    $b14b430a0537b433$var$load("65c4i"),
    $b14b430a0537b433$var$load("6wr18"),
    $b14b430a0537b433$var$load("kjZZD"),
    $b14b430a0537b433$var$load("3TTZL"),
    $b14b430a0537b433$var$load("37ldp"),
    $b14b430a0537b433$var$load("awqCy"),
    $b14b430a0537b433$var$load("kHOMt"),
    $b14b430a0537b433$var$load("hhss7"),
    $b14b430a0537b433$var$load("4kjaz"),
    $b14b430a0537b433$var$load("jE6Ik"),
    $b14b430a0537b433$var$load("dlZSj"),
    $b14b430a0537b433$var$load("Wowvf"),
    $b14b430a0537b433$var$load("dS0Pr"),
    $b14b430a0537b433$var$load("huYla"),
    $b14b430a0537b433$var$load("76Z06"),
    $b14b430a0537b433$var$load("6ojHB"),
    $b14b430a0537b433$var$load("ccoZQ"),
    $b14b430a0537b433$var$load("let0D"),
    $b14b430a0537b433$var$load("6EQss"),
    $b14b430a0537b433$var$load("6M36W"),
    $b14b430a0537b433$var$load("ffEVr"),
    $b14b430a0537b433$var$load("kUbUu"),
    $b14b430a0537b433$var$load("9ftJe"),
    $b14b430a0537b433$var$load("hUIij"),
    $b14b430a0537b433$var$load("6Up0b"),
    $b14b430a0537b433$var$load("lnKog"),
    $b14b430a0537b433$var$load("7Omhy"),
    $b14b430a0537b433$var$load("kC80R"),
    $b14b430a0537b433$var$load("7EorR"),
    $b14b430a0537b433$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("dVFAI"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("dVFAI", function(module, exports) {

let $a240dc5be70b389e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a240dc5be70b389e$var$load("hUIij"),
    $a240dc5be70b389e$var$load("6Up0b"),
    $a240dc5be70b389e$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.c7021f2d.js.map
